// extracted by mini-css-extract-plugin
export default {"app":"AppError_app__kmfi5"};